import Vue from 'vue';
const connectionHelper = Vue.mixin({
  data() {
    return {
      offlineListener: '',
      onlineListener: '',
    };
  },
  methods: {
    destroyListener() {
      if (this.offlineListener != '') {
        window.removeEventListener('offline', this.offlineListener);
      }
      if (this.onlineListener != '') {
        window.removeEventListener('online', this.onlineListener);
      }
    },
    initOfflineListener({ pathOffline, context }) {
      window.addEventListener('offline', async () => {
        context.$router.push(pathOffline);
      });
    },
    initOnlineListener({ pathOnline, context }) {
      window.addEventListener('online', async () => {
        context.$router.push(pathOnline);
      });
    },
  },
});

export default connectionHelper;
